<template>
  <FormGroupHorizontal 
    :label="$t('engine.manageText.modalWidget.lblLineHeight', languageEngine)"
    :labelValign="'center'"
    :labelTextClass="'flh-16'"
    :split="'3:9'"
    :paddingClosest="'8'"
  >
    <FontLineHeight
      :fontLineHeight="_value"
      :menuMaxHeight="'300px'"
      :menuDrop="'left'"
      @change="onChange"
    />
  </FormGroupHorizontal>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import FontLineHeight from "@components_system/Shared/Tools/FontLineHeight/FontLineHeight";

export default {
  components: {
    FormGroupHorizontal,
    FontLineHeight,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    value() {
      return this.texteditor.selectionFormatMerge.lineHeight;
    },
    _value() {
      if (!this.value) { return '1.2'; }
      if (Array.isArray(this.value)) return this.value[0];
      return this.value;
    }
  },
  methods: {
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      let tpFormatValue = this.texteditor.selectionFormatTemplate.lineHeight;
      let formatValue = value ? value : false;
      
      if (formatValue === tpFormatValue) formatValue = false;
      this.texteditor.editor.formatLine(selection, { 'lineHeight': formatValue });
      this.$emit('change', value);
    }
  },
}
</script>
